import type { HasAnyPrices } from "./types";

export const hasAnyPrices: HasAnyPrices = ({ settings }) =>
  settings.some((setting) =>
    setting.priceComponents.some(
      (component) =>
        component.suggestedAt !== null || component.manualSetAt !== null,
    ),
  );
